/** Fragmentos reutilizables para modales (UX-03: responsive). */
export const modalBoxNarrow = {
  width: "min(380px, 92vw)",
  maxWidth: "92vw",
  maxHeight: "85vh",
  overflowY: "auto",
};

export const modalBoxMedium = {
  width: "min(640px, 92vw)",
  maxWidth: "92vw",
  maxHeight: "85vh",
  overflowY: "auto",
};

export const modalBoxWide = {
  width: "min(850px, 92vw)",
  maxWidth: "92vw",
  maxHeight: "85vh",
  overflowY: "auto",
};
